/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion } from '../../conexiones';
import IFlujos from '../../negocioRefactor/entidades/repositorio/IFlujo';

export default class ModeloFlujos {
    public consultarFlujos() {
        return manejadorRest<IRespuesta<IFlujos>>(() => negocioConfiguracion.get('Flujo/ConsultarListaFlujo'));
    }
    public crearFlujos(flujos: IFlujos) {
        return manejadorRest<IRespuesta<IFlujos>>(() => negocioConfiguracion.post('Flujo/GuardarFlujo', flujos));
    }
    public editarFlujos(flujos: IFlujos) {
        return manejadorRest<IRespuesta<IFlujos>>(() => negocioConfiguracion.put('Flujo/EditarFlujo', flujos));
    }
    public eliminarFlujos(flujos: IFlujos) {
        return manejadorRest<IRespuesta<IFlujos>>(() => negocioConfiguracion.delete('Flujo/EliminarFlujo', flujos));
    }
    public consultarFlujosPorFiltro(flujos: Partial<IFlujos>) {
        return manejadorRest<IRespuesta<IFlujos>>(() => negocioConfiguracion.post('Flujo/ConsultarListaFlujoPorFiltro', flujos));
    }
}
